import { IInputOptions } from '@modeso/types__aumico-lib-notes-be';

export interface IInputOptionsDialogData {
    options: IInputOptions | undefined;
    languages: string[];
}
